import { render, staticRenderFns } from "./ReceituarioForm.vue?vue&type=template&id=b770f50e"
import script from "./ReceituarioForm.vue?vue&type=script&lang=js"
export * from "./ReceituarioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports